import styled from 'styled-components'

import { DeprecatedText } from '@syconium/little-miss-figgy'

export const SectionTitleWrapper = styled.div`
  display: flex;
`

export const RequiredText = styled(DeprecatedText)`
  font-size: 9px;
  text-transform: uppercase;
  margin-left: ${o => o.theme.spacing(1)};
  font-weight: ${o => o.theme.typography.deprecated.font.weight.semibold};
  color: ${o => o.theme.color.deprecated.red.error};
`
